import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .required("Password is required")
});

export const MediaSchema = Yup.array().of(
  Yup.mixed().test(
    "fileFormat",
    "Accepted file types: pdf, doc, docx, xlsx, xls, png, jpg, jpeg. Max file size: 1 MB.",
    (value: any) => {
      if (value) {
        const ext = value.name.split(".").pop();
        if (
          ext === "pdf" ||
          ext === "doc" ||
          ext === "docx" ||
          ext === "xlsx" ||
          ext === "xls" ||
          ext === "png" ||
          ext === "jpg" ||
          ext === "jpeg"
        )
          return value.size <= 1 * 1024 * 1024;
        else return false;
      } else return true;
    }
  )
);

export const MessageSchema = Yup.object().shape({
  message: Yup.string(),
  // .max(160, "Message cannot be more than 160 characters"),
  media: MediaSchema,
});

export const OneToOneMessageSchema = Yup.object().shape({
  number: Yup.string().matches(
    /^\+1\d{10}$/,
    "Invalid phone number format. Must start with +1 and contain 10 digits without any spaces."
  ),
  from_number: Yup.string().matches(
    /^\+1\d{10}$/,
    "Invalid phone number format. Must start with +1 and contain 10 digits without any spaces."
  ),
  message: Yup.string(),
  // .max(160, "Message cannot be more than 160 characters"),
  media: MediaSchema,
});

export const AddBlockListSchema = Yup.object({
  number: Yup.string()
    .matches(
      /^\+1\d{10}$/,
      "Invalid Phone Number.You can not block this number."
    )
    .required("Number is required"),
});

export const AddDispositionSchema = Yup.object({
  status: Yup.string().required("status is required.").trim(),
  campaign_id: Yup.number().required("Campaign ID is required."),
  number: Yup.string().matches(
    /^\+1\d{10}$/,
    "Invalid phone number format. Must start with +1 and contain 10 digits without any spaces."
  ),
});
